import requestApi from "../common/boxp_api_client";
import requestrApi from "../common/boxr_api_client";

// const addFinding = (formData) => {
//   return requestApi({
//     url: "sms/inputs/add_findings",
//     method: "POST",
//     data: formData,
//   });
// };

const getCategories = (params) => {
  return requestApi({
    url: "reports/get_categories",
    method: "GET",
    params: params,
  });
};

const getFavouriteReports = (params) => {
  return requestApi({
    url: "reports",
    method: "GET",
    params: params,
  });
};

const getAllReports = (params) => {
  return requestApi({
    url: "reports/all_reports",
    method: "GET",
    params: params,
  });
};

const getAdminReports = (params) => {
  return requestApi({
    url: "reports/admin_reports",
    method: "GET",
    params: params,
  });
};

const toggleFavourite = (params) => {
  return requestApi({
    url: "reports/toggle_favourite",
    method: "GET",
    params: params,
  });
};

const getReportParams = (params) => {
  return requestApi({
    url: "reports/report_params",
    method: "GET",
    params: params,
  });
};

const generateReport = (formData) => {
  return requestApi({
    url: "reports/generate_report",
    method: "POST",
    data: formData,
  });
};

const updateReportUserGroups = (formData) => {
  return requestApi({
    url: "reports/update_report_user_groups",
    method: "POST",
    data: formData,
  });
};

const updateReportUsers = (formData) => {
  return requestApi({
    url: "reports/update_report_users",
    method: "POST",
    data: formData,
  });
};

const ReportsServices = {
  updateReportUserGroups,
  updateReportUsers,
  getReportParams,
  getCategories,
  getAllReports,
  getFavouriteReports,
  getAdminReports,
  toggleFavourite,
  generateReport,
};

export default ReportsServices;
